import { FormattedMessage } from 'react-intl';
import ConfirmationButton from '../../ui/confirmationButton/ConfirmationButton';
import { Prompt } from '../../ui/prompt';
import styles from './PromptSave.module.css';
import messages from './PromptSave.messages';

export const PromptSave = (props) => {
    const { openPrompt, handleCancelPrompt, handleSubmitPrompt, loading } =
        props;

    if (openPrompt) {
        return (
            <Prompt className={styles.PromptSave}>
                <button onClick={handleCancelPrompt}>
                    <FormattedMessage {...messages.cancel} />
                </button>
                <ConfirmationButton
                    onClick={handleSubmitPrompt}
                    loading={loading}
                >
                    <FormattedMessage {...messages.save} />
                </ConfirmationButton>
            </Prompt>
        );
    } else {
        return null;
    }
};
